import { render, staticRenderFns } from "./Menlist.vue?vue&type=template&id=1fa7fa12&scoped=true"
import script from "./Menlist.vue?vue&type=script&lang=js"
export * from "./Menlist.vue?vue&type=script&lang=js"
import style0 from "./Menlist.vue?vue&type=style&index=0&id=1fa7fa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7fa12",
  null
  
)

export default component.exports